// Activities use China Standard Time. Never parse an offset-free value in the
// browser's local timezone (operators can use devices outside GMT+8).
const CST_OFFSET = 8 * 60 * 60 * 1000
const pad = value => String(value).padStart(2, '0')

export function parseActivityTime(value) {
  if (typeof value !== 'string') return null
  const match = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,3}))?(Z|[+-]\d{2}:?\d{2})?$/)
  if (!match) return null
  const [, year, month, day, hour, minute, second, fraction = '', zone] = match
  const parts = [year, month, day, hour, minute, second].map(Number)
  if (parts[0] < 100 || parts[1] < 1 || parts[1] > 12 || parts[2] < 1 || parts[3] > 23 || parts[4] > 59 || parts[5] > 59) return null
  const wallTime = Date.UTC(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5], Number(fraction.padEnd(3, '0')))
  const date = new Date(wallTime)
  if (date.getUTCFullYear() !== parts[0] || date.getUTCMonth() + 1 !== parts[1] || date.getUTCDate() !== parts[2]) return null
  let offset = CST_OFFSET
  if (zone === 'Z') offset = 0
  else if (zone) {
    const sign = zone[0] === '+' ? 1 : -1
    const digits = zone.slice(1).replace(':', '')
    const hours = Number(digits.slice(0, 2))
    const minutes = Number(digits.slice(2))
    if (hours > 23 || minutes > 59) return null
    offset = sign * (hours * 60 + minutes) * 60 * 1000
  }
  return wallTime - offset
}

export function formatActivityTime(value) {
  const timestamp = parseActivityTime(value)
  if (timestamp === null) return '-'
  const date = new Date(timestamp + CST_OFFSET)
  return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())} ${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}:${pad(date.getUTCSeconds())}`
}

export function formatActivityRemaining(milliseconds) {
  if (!Number.isFinite(milliseconds)) return '00:00:00'
  const seconds = Math.max(0, Math.ceil(milliseconds / 1000))
  const days = Math.floor(seconds / 86400)
  const clock = `${pad(Math.floor(seconds % 86400 / 3600))}:${pad(Math.floor(seconds % 3600 / 60))}:${pad(seconds % 60)}`
  return days ? `${days}天 ${clock}` : clock
}

export function activityTimeState(timeLimit, startTime, endTime, now) {
  if (Number(timeLimit) === 0 && timeLimit !== null && timeLimit !== undefined && timeLimit !== '') {
    return { key: 'unlimited', text: '不限时', hint: '活动不受开始、结束时间限制' }
  }
  if (Number(timeLimit) !== 1) return { key: 'invalid', text: '待配置时间', hint: '请选择是否限制时间' }
  const start = parseActivityTime(startTime)
  const end = parseActivityTime(endTime)
  if (start === null || end === null) return { key: 'invalid', text: '时间未完整配置', hint: '请选择完整、有效的开始与结束时间' }
  if (end <= start) return { key: 'invalid', text: '时间配置有误', hint: '结束时间必须晚于开始时间' }
  if (!Number.isFinite(now)) return { key: 'invalid', text: '时间状态暂不可用', hint: '请刷新页面后重试' }
  if (now < start) return { key: 'upcoming', text: `距开始 ${formatActivityRemaining(start - now)}`, hint: '尚未开始，当前订单不会触发本活动' }
  // Candidate matching uses start <= now and end > now: the end is exclusive.
  if (now >= end) return { key: 'expired', text: '已过期', hint: '有效期已结束，当前订单不会触发本活动；请调整时间后再使用' }
  return { key: 'active', text: `距结束 ${formatActivityRemaining(end - now)}`, hint: '当前在有效期内，是否触发仍需满足商品、身份及付款方式等规则' }
}
